import styled from "styled-components";
import { Classes } from "./common";
import type { ThemeProp, CommonComponentProps } from "./common";

export enum TextType {
  P1 = "p1",
  P2 = "p2",
  H6 = "h6",
}

enum Case {
  UPPERCASE = "uppercase",
  LOWERCASE = "lowercase",
  CAPITALIZE = "capitalize",
}

enum FontWeight {
  BOLD = "bold",
  NORMAL = "normal",
}

type TextProps = CommonComponentProps & {
  type: TextType;
  underline?: boolean;
  italic?: boolean;
  case?: Case;
  className?: string;
  weight?: FontWeight;
  highlight?: boolean;
};

const typeSelector = (props: TextProps & ThemeProp): string => {
  let color = "";
  switch (props.type) {
    case TextType.P1:
      color = props.theme.legacy.colors.text.normal;
      break;
    case TextType.P2:
      color = props.theme.legacy.colors.text.normal;
      break;
    default:
      color = props.theme.legacy.colors.text.heading;
      break;
  }
  return color;
};

const Text = styled.span.attrs((props: TextProps) => ({
  className: props.className ? props.className + Classes.TEXT : Classes.TEXT,
  "data-cy": props.cypressSelector,
}))<TextProps>`
  text-decoration: ${(props) => (props.underline ? "underline" : "unset")};
  font-style: ${(props) => (props.italic ? "italic" : "normal")};
  font-weight: ${(props) =>
    props.weight
      ? props.weight === FontWeight.BOLD
        ? props.theme.legacy.fontWeights[2]
        : "normal"
      : props.theme.legacy.typography[props.type].fontWeight};
  font-size: ${(props) => props.theme.legacy.typography[props.type].fontSize}px;
  line-height: ${(props) =>
    props.theme.legacy.typography[props.type].lineHeight}px;
  letter-spacing: ${(props) =>
    props.theme.legacy.typography[props.type].letterSpacing}px;
  color: ${(props) =>
    props.highlight
      ? props.theme.legacy.colors.text.hightlight
      : typeSelector(props)};
  text-transform: ${(props) => (props.case ? props.case : "none")};
`;

export default Text;
